import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)`
  @media (min-width: 2000px) {
    max-width: 1730px;
  }
  @media (max-width: 1999px) and (min-width: 1701px) {
    max-width: 1440px;
  }
  max-width: 1160px;
  margin: 0 auto;
`;
